import { ref } from 'vue';

/**
 * 路由 name（router）→ 该页根组件 name（与各自 .vue 中 name 一致，供 keep-alive include）。
 * 涵盖所有使用 components/Payment/PaymentView 或全页 views/PaymentView 的入口。
 */
export const PAYMENT_PARENT_ROUTE_TO_COMPONENT = [
  { route: 'payment', component: 'PaymentView' },
  { route: 'getDclaw', component: 'DclawRedV1' },
  { route: 'getDclawReferral', component: 'GetDclawReferralH5' },
  { route: 'getDclawAgent', component: 'GetDclawAgentH5' },
  { route: 'getCoordinates', component: 'GetCoordinates' },
  { route: 'applyServiceProvider', component: 'ApplyServiceProvider' },
  { route: 'searchCoordinates', component: 'searchCoordinates' },
  { route: 'myLock', component: 'myLock' },
  { route: 'historyRecord', component: 'historyRecord' },
  { route: 'coordinatesShare', component: 'coordinatesShare' },
  { route: 'landDetails', component: 'LandDetails' },
  { route: 'digitalCollectionDetails', component: 'DigitalCollectionDetails' },
  { route: 'account', component: 'AccountView' },
  { route: 'electricity', component: 'ElectricityView' },
  { route: 'BruceLeeCard', component: 'BruceLeeCard' },
  { route: 'gzq2024', component: 'Gzq2024View' },
  { route: 'surname', component: 'PlanetSurnameView' },
  { route: 'ticket', component: 'ScratchTicketView' },
  { route: 'xnfd', component: 'XnfdView' },
];

/** 从支付页跳转协议页再返回时需保留状态的协议路由 */
export const AGREEMENT_ROUTE_NAMES = ['purchaseNotes', 'referralDistributionAgreement'];

function isAgreementRoute(routeName) {
  return AGREEMENT_ROUTE_NAMES.includes(routeName);
}

/** 当前允许被 keep-alive 缓存的支付相关根组件名（从支付页进入协议页再返回时加入） */
export const purchaseNotesReturnCacheComponentNames = ref([]);

export function updatePaymentParentsKeepAliveForPurchaseNotes(to, from) {
  const fromName = from.name;
  const toName = to.name;
  const set = new Set(purchaseNotesReturnCacheComponentNames.value);

  for (const { route, component } of PAYMENT_PARENT_ROUTE_TO_COMPONENT) {
    if (toName === route && !isAgreementRoute(fromName)) {
      set.delete(component);
    }
    if (fromName === route && isAgreementRoute(toName)) {
      set.add(component);
    }
    if (fromName === route && !isAgreementRoute(toName)) {
      set.delete(component);
    }
  }

  purchaseNotesReturnCacheComponentNames.value = Array.from(set);
}
